var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.994 22.174h-16.24v-4.07c0-.314.254-.568.566-.568h15.107c.314 0 .567.254.567.568v4.07zM41.994 22.174l5.25 4.602v.675h-13.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.244 26.776l.077 5.17a2.67 2.67 0 01-2.663 2.716 2.67 2.67 0 01-2.664-2.677v-4.534M41.994 27.451l-.03 4.494a2.67 2.67 0 01-2.664 2.717 2.67 2.67 0 01-2.664-2.676v-4.535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.636 27.451l-.03 4.494a2.67 2.67 0 01-2.664 2.717M25.754 22.174l-1.443 1.33M45.075 34.625v12.243h-17.58M31.113 41.109v5.76M31.339 33.296c0 4.385-7.903 13.572-7.903 13.572s-7.903-9.187-7.903-13.572c0-4.383 3.538-7.937 7.903-7.937 4.364 0 7.903 3.554 7.903 7.937z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.953 33.296a2.522 2.522 0 01-2.517 2.529 2.522 2.522 0 01-2.516-2.529 2.522 2.522 0 012.516-2.527 2.522 2.522 0 012.517 2.527z"
  }))));
};
export default SvgShop;